/* global bootstrap */

// Function to randomly select 4 testimonials on each page
const testimonialRandomSelection = (testimonialId) => {
  const testimonialContainer = document.querySelector(testimonialId);
  if (!testimonialContainer) {
    return;
  }
  
  // Get all the testimonial items in carousel
  const testimonialsArray = Array.from(testimonialContainer.querySelectorAll('.carousel-inner .carousel-item'));
  // Carousel parent where we need to append testimonials
  const testimonialParent = testimonialContainer.querySelector('.carousel-inner');
  
  if (!testimonialParent || testimonialsArray.length === 0) {
    return;
  }
  
  // Storing testimonial array to a temporary array
  const temporaryTestimonialArray = [...testimonialsArray];
  // Initializing count to select only 4 testimonials in a page
  let count = 0;
  // Empty testimonial parent
  testimonialParent.innerHTML = '';
  
  // Get the length of temp array
  const tempTestimonialLength = temporaryTestimonialArray.length;
  
  // Looping to get only 4 random testimonials
  while (count < 4 && temporaryTestimonialArray.length > 0) {
    // Get random index value
    const randomIndex = Math.floor(Math.random() * (tempTestimonialLength - count));
    // Get random item from testimonial array
    const randomItem = temporaryTestimonialArray[randomIndex];
    
    // Set active class/state to the 1st testimonial item
    if (count === 0) {
      randomItem.classList.add('active');
    }
    
    // Append the random testimonial item to the parent
    testimonialParent.appendChild(randomItem);
    // Remove that testimonial item appended from temporary array to avoid repeatation
    temporaryTestimonialArray.splice(randomIndex, 1);
    count++;
  }
};

// swipe testimonial left and right in mobile
// On touch on carousel item in mobile
const mobileSwipeCarousel = (event, id) => {
  // Get the x position on touch start
  const xPositionClicked = event.touches[0].pageX;
  // Get the y position on touch start
  const yPositionClicked = event.touches[0].pageY;
  
  const touchMoveHandler = (e) => {
    // Get the x position on touch move
    const xPositionMoved = e.touches[0].pageX;
    // Get the y position on touch move
    const yPositionMoved = e.touches[0].pageY;

    // If there is touch move in top-bottom direction, prevent touchmove event
    if (Math.floor(yPositionClicked - yPositionMoved) !== 0) {
      event.currentTarget.removeEventListener('touchmove', touchMoveHandler);
    }
    
    // If the difference between x positions on start and move is +ve and sensitivity > 5, swipe right
    if (Math.floor(xPositionClicked - xPositionMoved) > 5) {
      const carousel = document.querySelector(id);
      if (carousel && typeof bootstrap !== 'undefined') {
        const carouselInstance = bootstrap.Carousel.getInstance(carousel) || new bootstrap.Carousel(carousel);
        carouselInstance.next();
      }
    }
    // If the difference between x positions on start and move is -ve and sensitivity < -5, swipe left
    else if (Math.floor(xPositionClicked - xPositionMoved) < -5) {
      const carousel = document.querySelector(id);
      if (carousel && typeof bootstrap !== 'undefined') {
        const carouselInstance = bootstrap.Carousel.getInstance(carousel) || new bootstrap.Carousel(carousel);
        carouselInstance.prev();
      }
    }
  };
  
  event.currentTarget.addEventListener('touchmove', touchMoveHandler);
  
  // On touch end/ when the user removes the finger from the element, stop the touchmove event
  const carouselInner = document.querySelector(`${id} .carousel-inner`);
  if (carouselInner) {
    carouselInner.addEventListener('touchend', () => {
      event.currentTarget.removeEventListener('touchmove', touchMoveHandler);
    });
  }
};

const carouselTestimonial = (testimonial) => {
  const initCarousel = () => {
    const carousel = document.querySelector(testimonial);
    if (!carousel) {
      return;
    }
    
    const totalItems = carousel.querySelectorAll('.carousel-item').length;
    
    // Get all slide-count elements
    const slideCountDisplays = carousel.querySelectorAll('.slide-count');
    
    if (slideCountDisplays.length === 0) {
      return;
    }
    
    // Check if mobile to adjust behavior
    const isMobile = window.innerWidth <= 768;
    
    // Debounce function for mobile to prevent rapid updates
    let updateTimeout;
    
    // Function to update all slide counters
    const updateAllSlideCounters = (index, total) => {
      if (isMobile) {
        // Clear previous timeout
        clearTimeout(updateTimeout);
        // Add small delay for mobile to prevent jitter
        updateTimeout = setTimeout(() => {
          slideCountDisplays.forEach((slideCountDisplay) => {
            if (slideCountDisplay) {
              slideCountDisplay.innerHTML = `${index}/${total}`;
            }
          });
        }, 50);
      } else {
        // Instant update for desktop
        slideCountDisplays.forEach((slideCountDisplay) => {
          if (slideCountDisplay) {
            slideCountDisplay.innerHTML = `${index}/${total}`;
          }
        });
      }
    };
    
    // Initialize counters on page load
    const initializeCounters = () => {
      const activeElement = carousel.querySelector('div.carousel-item.active');
      let currentIndex = 1;
      
      if (activeElement && activeElement.parentElement) {
        const siblings = activeElement.parentElement.children;
        currentIndex = Array.from(siblings).indexOf(activeElement) + 1;
      }
      
      updateAllSlideCounters(currentIndex, totalItems);
    };
    
    // Initialize counters
    initializeCounters();

    // For mobile, use the completed slide event to reduce jitter
    const eventType = isMobile ? 'slid.bs.carousel' : 'slide.bs.carousel';
    
    carousel.addEventListener(eventType, (event) => {
      if (isMobile) {
        // For mobile, get current active slide after transition
        const activeItem = carousel.querySelector('div.carousel-item.active');
        if (activeItem && activeItem.parentElement) {
          const currentIndex = Array.from(activeItem.parentElement.children).indexOf(activeItem) + 1;
          updateAllSlideCounters(currentIndex, totalItems);
        }
      } else {
        // For desktop, use immediate event
        if (event.to !== undefined) {
          updateAllSlideCounters(event.to + 1, totalItems);
        }
      }
    });
  };
  
  // Ensure DOM is ready before initializing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    // DOM is already loaded
    initCarousel();
  }
};

const carouselNormalization = () => {
  window.heights = []; //create empty array to store height values

  const normalizeHeights = () => {
    const itemDetails = document.querySelectorAll('.multi-item-carousel .carousel-inner .carousel-item .item-details');
    
    itemDetails.forEach((element) => {
      window.heights.push(element.offsetHeight);
    });
    
    window.tallest = Math.max(...window.heights);
    
    itemDetails.forEach((element) => {
      const children = element.children;
      Array.from(children).forEach((child) => {
        child.style.minHeight = `${window.tallest}px`;
      });
    });
  };
  normalizeHeights();
};

export {
  carouselTestimonial,
  carouselNormalization,
  mobileSwipeCarousel,
  testimonialRandomSelection,
};